import AddPolicy from "../pages/Policies/AddPolicy.tsx";
import Home from "../pages/Dashboard/Home.tsx";
import PolicyAnnex from "../pages/Policies/PolicyAnnex.tsx";
import ClientData from "../pages/ClientData/ClientData.tsx";
import VehicleData from "../pages/VehicleData/VehicleData.tsx";
import NewPolicy from "../pages/NewDocuments/NewPolicy.tsx";
import NewDocument from "../pages/NewDocuments/NewDocument.tsx";
import PolicyReference from "../pages/PolicyReference/PolicyReference.tsx";
import InsuranceCompaniesManagement from "../pages/InsuranceCompaniesManagement/InsuranceCompaniesManagement.tsx";
import CommissionsSettings from "../pages/CommissionsSettings/CommissionsSettings.tsx";
import PoliciesSettings from "../pages/PoliciesSettings/PoliciesSettings.tsx";
import OfficesAndAgentsManagement from "../pages/OfficesAndAgentsManagement/OfficesAndAgentsManagement.tsx";
import OfficeManagement from "../pages/OfficeManagement/OfficeManagement.tsx";
import CommercialConsultants from "../pages/CommercialConsultants/CommercialConsultants.tsx";
import UserManagement from "../pages/UserManagement/UserManagement.tsx";
import { ComponentType } from "react";
import InsuranceCompanyReport from "../pages/InsuranceCompanyReport/InsuranceCompanyReport.tsx";
import ReportedInsurances from "../pages/ReportedInsurances/ReportedInsurances.tsx";
import DocumentSearch from "../pages/DocumentSearch/DocumentSearch.tsx";
import EmptyDocuments from "../pages/EmptyDocuments/EmptyDocuments.tsx";
import ActivityLog from "../pages/ActivityLog/ActivityLog.tsx";
import BrokerReport from "../pages/BrokerReport/BrokerReport.tsx";
import DailyReport from "../pages/DailyReport/DailyReport.tsx";
import AgentReport from "../pages/AgentReport/AgentReport.tsx";
import BankReport from "../pages/BankReport/BankReport.tsx";
import FinancialAuditReport from "../pages/FinancialAuditReport/FinancialAuditReport.tsx";
import Ozk from "../pages/Integrations/Ozk/Ozk.tsx";
import Dzi from "../pages/Integrations/Dzi/Dzi.tsx";
import Generali from "../pages/Integrations/Generali/Generali.tsx";
import LevIns from "../pages/Integrations/LevIns/LevIns.tsx";
import Lifecycle from "../pages/Integrations/Lifecycle/Lifecycle.tsx";
import POSReport from "../pages/POSReport/POSReport.tsx";
import DocumentsPPP from "../pages/DocumentsPPP/DocumentsPPP.tsx";
import KFNOperationsReport from "../components/DataTables/KFNOperationsReport.tsx";
import AwaitingPaymentReport from "../pages/AwaitingPaymentReport/AwaitingPaymentReport.tsx";
import InsuranceCalculator from "../pages/InsuranceCalculator/InsuranceCalculator.tsx";

interface AppRoute {
  path: string;
  title: string;
  component: ComponentType<any>;
}

export const routesConfig: AppRoute[] = [
  { path: "/", title: "Home", component: Home },
  { path: "/policies/new", title: "Работа с полици", component: AddPolicy },
  {
    path: "/policies/issue",
    title: "Издаване на полица",
    component: Lifecycle,
  },
  { path: "/policies/change", title: "Добавъци", component: PolicyAnnex },
  { path: "/policies/client", title: "Данни за клиент", component: ClientData },
  { path: "/policies/vehicle", title: "Данни за МПС", component: VehicleData },
  { path: "/policies/new/policy", title: "Нови полици", component: NewPolicy },
  {
    path: "/policies/ppp",
    title: "ППП на Документи",
    component: DocumentsPPP,
  },
  {
    path: "/policies/new/documents",
    title: "Нови документи",
    component: NewDocument,
  },
  {
    path: "/references/expiring-policies",
    title: "Изтичащи полици",
    component: PolicyReference,
  },
  {
    path: "/references/awaiting-payment-report",
    title: "Изчакващи плащане",
    component: AwaitingPaymentReport,
  },
  {
    path: "/references/policy-installments",
    title: "Поредни вноски",
    component: PolicyReference,
  },
  {
    path: "/system/insurance-company-report",
    title: "Отчет към ЗК",
    component: InsuranceCompanyReport,
  },
  {
    path: "/references/broker-report",
    title: "Дневник на Брокера",
    component: BrokerReport,
  },
  {
    path: "/system/kfn-report",
    title: "Справка за КФН",
    component: FinancialAuditReport,
  },
  {
    path: "/system/kfn-operations-report",
    title: "Оперативни справки за КФН",
    component: KFNOperationsReport,
  },
  {
    path: "/references/daily-report",
    title: "Дневно приключване",
    component: DailyReport,
  },
  {
    path: "/references/agent-report",
    title: "Отчет на Агент",
    component: AgentReport,
  },
  {
    path: "/references/reported-insurances",
    title: "Отчетени полици в ЗК",
    component: ReportedInsurances,
  },
  {
    path: "/references/document-search",
    title: "Търсене по номер на документ",
    component: DocumentSearch,
  },
  {
    path: "/references/empty-documents",
    title: "Празни документи",
    component: EmptyDocuments,
  },
  {
    path: "/system/activity-log",
    title: "Движение на документи",
    component: ActivityLog,
  },
  {
    path: "/system/bank-report",
    title: "Отчет по банка",
    component: BankReport,
  },

  {
    path: "/system/pos-report",
    title: "Отчет по ПОС",
    component: POSReport,
  },
  { path: "/settings/users", title: "Потребители", component: UserManagement },
  {
    path: "/settings/consultants",
    title: "Рекламни консултанти",
    component: CommercialConsultants,
  },
  { path: "/settings/offices", title: "Офиси", component: OfficeManagement },
  {
    path: "/settings/offices-and-agents",
    title: "Офиси и Агенти",
    component: OfficesAndAgentsManagement,
  },
  {
    path: "/settings/policies",
    title: "Видове полици",
    component: PoliciesSettings,
  },
  {
    path: "/settings/commissions",
    title: "Комисионни",
    component: CommissionsSettings,
  },
  {
    path: "/settings/insurance-companies",
    title: "Застрахователни компании",
    component: InsuranceCompaniesManagement,
  },
  {
    path: "/integrations/ozk",
    title: "ОЗК",
    component: Ozk,
  },
  {
    path: "/integrations/dzi",
    title: "ДЗИ",
    component: Dzi,
  },
  {
    path: "/integrations/generali",
    title: "Дженерали",
    component: Generali,
  },
  {
    path: "/integrations/levins",
    title: "Лев Инс",
    component: LevIns,
  },
  {
    path: "/integrations/insurance-calculator",
    title: "Калкулатор",
    component: InsuranceCalculator,
  },
];
